import { useEffect } from 'react';
import { Link, NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { auMoins } from '@rh/shared';
import { useAuth } from './auth/contexte-auth';
import { BandeauEnvoi } from './composants/BandeauEnvoi';
import { BarreStatut } from './composants/BarreStatut';
import { ConfirmerDeconnexion } from './composants/ConfirmerDeconnexion';
import { MenuPrincipal } from './composants/MenuPrincipal';
import { SaisiesAutreCompte } from './composants/SaisiesAutreCompte';
import { useDeconnexion, useFile } from './horsligne/contexte-file';
import { useHauteurEntete } from './hauteur-entete';
import { appliquerApparence } from './theme';
import { Annonces } from './pages/Annonces';
import { Connexion } from './pages/Connexion';
import { Conservation } from './pages/Conservation';
import { CvARattacher } from './pages/CvARattacher';
import { EditionAnnonce } from './pages/EditionAnnonce';
import { Employes } from './pages/Employes';
import { EnvoisEnAttente } from './pages/EnvoisEnAttente';
import { FicheCandidat } from './pages/FicheCandidat';
import { FicheEmploye } from './pages/FicheEmploye';
import { Ingestion } from './pages/Ingestion';
import { ListeCandidatures } from './pages/ListeCandidatures';
import { PanneauContact } from './pages/PanneauContact';
import { Recherche } from './pages/Recherche';
import { AdminBaremes } from './pages/AdminBaremes';
import { AdminComptes } from './pages/AdminComptes';
import { AdminJournal } from './pages/AdminJournal';
import { AdminReferentiels } from './pages/AdminReferentiels';
import { MonCompte } from './pages/MonCompte';
import { Parametres } from './pages/Parametres';
import { ScanCharte } from './pages/ScanCharte';
import { ScanRapport } from './pages/ScanRapport';
import { Comparateur } from './pages/Comparateur';
import { Statistiques } from './pages/Statistiques';
import { Suivi } from './pages/Suivi';

export function App() {
  const { utilisateur, chargement, sessionFragile } = useAuth();
  const { instantane } = useFile();
  const { demander } = useDeconnexion();
  const mesurerEntete = useHauteurEntete();
  const apparence = utilisateur?.apparence;
  // Le style suit le compte connecté ; déconnecté, le dernier appliqué reste.
  useEffect(() => {
    if (apparence) appliquerApparence(apparence);
  }, [apparence]);
  if (chargement) return <p className="attente">Chargement…</p>;
  if (!utilisateur) return <Connexion />;
  const rh = auMoins(utilisateur.role, 'rh');
  // Page « Paramètres » : le super admin seul la voit et l'ouvre (l'API refuse aussi les autres).
  const superAdmin = utilisateur.role === 'super_admin';
  const envois = instantane.enAttente + instantane.refusees;

  return (
    <div className="cadre">
      {/* En-tête épinglé : bouton du menu, logo et statut sur la même ligne (le statut
          passe dessous sur téléphone, faute de place). */}
      <header ref={mesurerEntete}>
        <MenuPrincipal rh={rh} superAdmin={superAdmin} onDeconnexion={() => void demander()} />
        <Link to="/annonces" className="titre-appli" aria-label="RH Plaisirs Gourmands, retour aux annonces">
          <img src="/logo-plaisirs-gourmands.png" alt="" className="logo-entete logo-clair" />
          <img src="/logo-plaisirs-gourmands-sombre.png" alt="" className="logo-entete logo-sombre" />
          <span className="suffixe-rh">RH</span>
        </Link>
        <BarreStatut utilisateur={utilisateur} enLigne={instantane.enLigne} sessionFragile={sessionFragile} />
        <div className="identite">
          {envois > 0 && (
            <NavLink to="/envois" className="lien-envois">
              Envois ({envois})
            </NavLink>
          )}
        </div>
      </header>
      <BandeauEnvoi />

      <main>
        <Routes>
          <Route path="/" element={<Navigate to="/annonces" replace />} />
          <Route path="/annonces" element={<Annonces />} />
          {rh && <Route path="/annonces/nouvelle" element={<EditionAnnonce />} />}
          <Route path="/annonces/:id" element={<ListeCandidatures />} />
          <Route path="/annonces/:id/edition" element={<EditionAnnonce />} />
          <Route path="/candidatures/:id" element={<FicheCandidat />} />
          {rh && <Route path="/candidatures/:id/charte/scan" element={<ScanCharte />} />}
          {rh && <Route path="/candidatures/:id/rapport/scan" element={<ScanRapport />} />}
          <Route path="/contacts/:id" element={<PanneauContact />} />
          {rh && <Route path="/recherche" element={<Recherche />} />}
          {rh && <Route path="/envois" element={<EnvoisEnAttente />} />}
          <Route path="/suivi" element={<Suivi />} />
          <Route path="/employes" element={<Employes />} />
          <Route path="/employes/:id" element={<FicheEmploye />} />
          <Route path="/statistiques" element={<Statistiques />} />
          <Route path="/comparateur" element={<Comparateur />} />
          {rh && <Route path="/cv-a-rattacher" element={<CvARattacher />} />}
          {rh && <Route path="/conservation" element={<Conservation />} />}
          {rh && <Route path="/ingestion" element={<Ingestion />} />}
          {superAdmin && <Route path="/parametres" element={<Parametres />} />}
          {superAdmin && <Route path="/administration" element={<Navigate to="/administration/comptes" replace />} />}
          {superAdmin && <Route path="/administration/comptes" element={<AdminComptes />} />}
          {superAdmin && <Route path="/administration/referentiels" element={<AdminReferentiels />} />}
          {superAdmin && <Route path="/administration/baremes" element={<AdminBaremes />} />}
          {superAdmin && <Route path="/administration/journal" element={<AdminJournal />} />}
          <Route path="/mon-compte" element={<MonCompte />} />
          <Route path="*" element={<Navigate to="/annonces" replace />} />
        </Routes>
      </main>
      <SaisiesAutreCompte />
      <ConfirmerDeconnexion />
    </div>
  );
}
